import { useEffect } from "react";
import {
  ensureShoppingListsReady,
  selectAllShoppingLists,
  useAppSelector,
} from "@reciperoll/core";
import { useAuth } from "../lib/auth";
import { store } from "../store/store";

// Ensures a single primary shopping list exists (created with the user's id for
// multi-device dedupe), reconciles any duplicate primaries, and backfills legacy
// items — once auth has resolved, so the deterministic id is available. Re-runs
// when the number of primary lists changes, so a duplicate that arrives via a
// sync pull after launch is reconciled without needing a relaunch. Renders nothing.
export function ShoppingListsBootstrap() {
  const { session, loading } = useAuth();
  const userId = session?.user?.id;
  const primaryCount = useAppSelector(
    (s) => selectAllShoppingLists(s).filter((l) => l.isPrimary).length,
  );
  useEffect(() => {
    if (!loading) ensureShoppingListsReady(store, userId);
  }, [loading, userId, primaryCount]);
  return null;
}
